import {getReservationList, signReOrder} from "@/api";
import {message} from "../../utils/common";
import {ElMessageBox} from "element-plus";
import baseConfig from "@/api/config";

export default {
    data() {
        return {
            currentPage: 1,
            pageNums: 20,
            totalCount: 0,
            queryParams: {
                cardPatientName: '',
                cardIdentity: '',
                reStatusMiniDoc: '',
                cardPatientPhone: ''
            },
            tableLoading: false,
            tableData: [],
            dateTime: '',
            tableHeight: 500,
            tencentCosUrl: baseConfig.tencentCosUrl,
            doctorInfo: null,
            patientInfo: {}
        }
    },
    mounted() {
        //此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
        setTimeout(() => {
            if (this.$refs.multipleTable && this.$refs.multipleTable.$el) {
                this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 80;
            }
        },1000)
    },
    created() {
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            this.patientInfo.docId = this.doctorInfo.doctorId;
        }
        this.getReservationListInfo();
    },
    methods: {
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams.cardPatientName = "";
            this.queryParams.reStatusMiniDoc = "";
            this.queryParams.cardIdentity = "";
            this.queryParams.cardPatientPhone = "";
            this.getReservationListInfo();
        },

        // 选择预约状态
        chooseStatus() {
            this.currentPage = 1;
            this.getReservationListInfo();
        },

        // 切换分页
        handleCurrentChange: function(val) {
            this.currentPage = val;
            this.getReservationListInfo();
        },

        // 切换分页
        handleSizeChange: function(val) {
            this.pageNums = val;
            this.getReservationListInfo();
        },


        // 查询预约列表
        getReservationListInfo: function () {
            this.tableData = [];
            this.tableLoading = true;
            const data = {
                pageNum: this.currentPage,
                pageSize: this.pageNums,
                doctorId: this.doctorInfo ? this.doctorInfo.doctorId : null,
                cardIdentity: this.queryParams.cardIdentity,
                cardPatientName: this.queryParams.cardPatientName,
                reStatusMiniDoc: this.queryParams.reStatusMiniDoc,
                cardPatientPhone: this.queryParams.cardPatientPhone,
            };
            getReservationList(data).then(res => {
                const rdata = res.data;
                this.tableLoading = false;
                if (rdata.code === 200) {
                    this.tableData = rdata.rows;
                    this.totalCount = rdata.total;

                    this.tableData.forEach((item) => {
                        let birYear = new Date(item.cardPatientBirth).getFullYear();
                        let nowYear = new Date().getFullYear();
                        item.age = parseInt(nowYear - birYear);
                        item.reTimeTypeText = item.reTimeType === 'am'?'上午': item.reTimeType === 'pm'?'下午':'晚上';
                        item.reStatusText = item.reStatus === '1'?'待支付':item.reStatus === '2'?
                            '已完成':item.reStatus === '3'?'已失效':item.reStatus === '4'?'已取消':item.reStatus === '5'?'待就诊':item.reStatus === '6'?'就诊中':item.reStatus === '7'?'已过号':item.reStatus === '8'?'待签到':'未知';
                        if (item.cardPatientSex === '0') {
                            item.sexText = '男';
                            item.avatar = item.cardPatientHeadPic ? this.toAvatarUrl(item.cardPatientHeadPic) : this.tencentCosUrl + "/tcmmsPic/manImg.png";
                        } else if (item.cardPatientSex === '1'){
                            item.sexText = '女';
                            item.avatar = item.cardPatientHeadPic ? this.toAvatarUrl(item.cardPatientHeadPic) : this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                        } else {
                            item.sexText = '未知';
                            item.avatar = item.cardPatientHeadPic ? this.toAvatarUrl(item.cardPatientHeadPic) : this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                        }
                    })
                }
            }).catch(error => {
                message(error, "error");
            });
        },


        toAvatarUrl(value) {
            return /^https?:\/\//i.test(value) ? value : this.tencentCosUrl + value;
        },

        // 签到
        handleSign(row) {
            const reId = row.reId;
            ElMessageBox.confirm('确定要签到？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info',
            }).then(() => {
                signReOrder(reId).then(res => {
                    if (res.code === 200) {
                        //后端签到时分配当天排队号，随签到结果回传
                        message(res.data ? "签到成功，排队" + res.data + "号" : "签到成功", "success");
                        this.getReservationListInfo();
                    } else {
                        message(res.msg || "签到失败", "warning");
                        this.getReservationListInfo();
                    }
                }).catch(error => {
                    message(error, "error");
                });
            }).catch(() => {});
        },

    }
}
